(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('NewsDialogController', NewsDialogController);

    NewsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'News', 'Customer', 'ServiceItem', 'CompanyCustom', '$translate', '$translatePartialLoader'];

    function NewsDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, News, Customer, ServiceItem, CompanyCustom, translate, translatePartialLoader) {
        var vm = this;

        vm.news = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.addCompanyType = addCompanyType;
        vm.companyType = null;
        vm.clearCompanyTypes = clearCompanyTypes;

        vm.subscriptionType = null;
        vm.addSubscriptionType = addSubscriptionType;
        vm.clearSubscriptionTypes = clearSubscriptionTypes;

        loadPage();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function loadPage() {
            translatePartialLoader.addPart('activityType');
            loadAllCompanyTypes();
            loadAllSubscriptionTypes();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.news.id !== null) {
                News.update(vm.news, onSaveSuccess, onSaveError);
            } else {
                News.save(vm.news, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:newsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAllCompanyTypes() {
            vm.allCompanyTypes = CompanyCustom.getCompanyActivityTypes();
        }

        function loadAllSubscriptionTypes() {
            vm.allSubscriptionTypes = ['FREE', 'BASIC', 'ECONOMY', 'ENTERPRISE', 'CUSTOM'];
        }

        function addCompanyType() {
            if (vm.companyType) {
                if (!vm.news.companyTypeObject)
                    vm.news.companyTypeObject = {};

                if (!vm.news.companyTypeObject.activityTypeList)
                    vm.news.companyTypeObject.activityTypeList = [];

                vm.news.companyTypeObject.activityTypeList.push(vm.companyType);

            }
        }

        function clearCompanyTypes() {
            if (!vm.news.companyTypeObject)
                vm.news.companyTypeObject = {};

            if (!vm.news.companyTypeObject.activityTypeList)
                vm.news.companyTypeObject.activityTypeList = [];

            vm.news.companyTypeObject = null;

        }

        function addSubscriptionType() {
            if (vm.subscriptionType) {
                if (!vm.news.subscriptionTypeObject)
                    vm.news.subscriptionTypeObject = {};

                if (!vm.news.subscriptionTypeObject.subscriptionTypeList)
                    vm.news.subscriptionTypeObject.subscriptionTypeList = [];

                vm.news.subscriptionTypeObject.subscriptionTypeList.push(vm.subscriptionType);

            }
        }

        function clearSubscriptionTypes() {
            if (!vm.news.subscriptionTypeObject)
                vm.news.subscriptionTypeObject = {};

            if (!vm.news.subscriptionTypeObject.subscriptionTypeList)
                vm.news.subscriptionTypeObject.subscriptionTypeList = [];

            vm.news.subscriptionTypeObject.subscriptionTypeList = [];

        }
    }
})();
